export default __webpack_public_path__ + "static/media/contact.0289356b.svg";